import type { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import type { Light } from "@babylonjs/core/Lights/light";

/** Embedded eye/harness lights illuminate the surroundings, not their own coat. */
export function excludeSelfLight(light: Light, meshes: AbstractMesh[]): () => void {
  const added = meshes.filter(mesh => mesh.getTotalVertices() > 0 && !light.excludedMeshes.includes(mesh));
  light.excludedMeshes.push(...added);
  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    light.onDisposeObservable.remove(observer);
    light.excludedMeshes = light.excludedMeshes.filter(mesh => !added.includes(mesh));
  };
  // Scene disposal destroys Babylon nodes directly; it need not call the
  // PlayerEntity wrapper's dispose(). Release references at the light owner too.
  const observer = light.onDisposeObservable.addOnce(release);
  return release;
}
